import { render, staticRenderFns } from "./historyRecord.vue?vue&type=template&id=21820c7a&"
import script from "./historyRecord.vue?vue&type=script&lang=js&"
export * from "./historyRecord.vue?vue&type=script&lang=js&"
import style0 from "./historyRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports